module.exports = __webpack_public_path__ + "672d2afe4f40a766e46ff95379550c4f.woff";